import Http from '@/utils/http'
const baseUrl = '/app/student'

/**
 *我的团队文案列表
 * @param params
 * 
*/

export const myCopywriting = params => Http.get(`${baseUrl}/sz/team/jb/my`, { params })

/**
 *脚本列表
 * @param waId
 * 
*/

export const scenarioList = waId => Http.get(`${baseUrl}/sz/team/jb/my/${waId}`)

/**
 *管理脚本
 * @param params
 * 
*/

export const save = params => Http.post(`${baseUrl}/sz/team/jb/my/${params.waId}`,  params.list )

/**
 *团队成果
 * @param params
 * 
*/

export const result = params => Http.get(`${baseUrl}/sz/team/jb`, { params })
